import { HomePostsController } from './home-posts.controller'

function homePosts () {
  return {
    restrict: 'E',
    templateUrl: '/home/directives/home-posts/home-posts-directive.html?$$REVISION$$',
    controller: HomePostsController
  }
}

export { homePosts }
